// Public routes (Auth)
export const LOGIN = "/login";
export const SIGN_UP = "/signup";
export const FORGETPASS = "/forgot-password";
export const RESETPASS = "/reset-password";
export const VERIFY = "/auth/email-verification";

//  Main
export const DASHBOARD = "/";
export const PROFILE = "/profile";
export const SETTINGS = "/settings";
export const SETTINGSCARTFUNNEL = "/settings/cart-funnel";
export const SETTINGS_ABANDONED_CART_SMS = "/settings/abandoned-cart-sms";
export const SETTINGSEMAILTEMPLATES = "/settings/email-templates";
export const SETTINGSCREATEEMAILTEMPLATES = "/settings/create-email-templates";
export const SETTINGSUPDATEMAILTEMPLATES = "/settings/update/:id";
export const EMAIL_BUILDER_NEW = "/email-builder/new";
export const EMAIL_BUILDER_EDIT = "/email-builder/edit/:id";
export const EMAIL_TEMPLATE_DETAIL = "/email-template/details/:id";
export const SETTINGS_PENDINGORDER = "/settings/pending-order";
export const SETTINGS_AFFILIATE = "/settings/affiliate";
export const AFFILIATE_SETTINGS = "/affiliate-settings";
export const EMAILTEMPLATE_SETTING = "/settings/email-settings";
export const EMAILTEMPLATE_FOOTER_SETTING = "/setting/email-settings/footer";
export const SMS_SETTING = "/settings/sms";

//  Products
export const PRODUCTS_LIST = "/products";
export const PRODUCT_ADD = "/product/add";
export const PRODUCTDETAIL = "/product/details/:id";
export const UPDATEPRODUCT = "/product/update/:id";
export const REVIEWS_LIST = "/reviews";
export const REVIEWDETAIL = "/review/details/:id";
export const UPDATEREVIEW = "/review/update/:id";

//  Users
export const USER_LIST = "/users";
export const USER_ADD = "/user/add";
export const USERDETAIL = "/user/details/:id";
export const UPDATEUSER = "/user/update/:id";

//  Roles
export const ROLE_LIST = "/roles";
export const ROLE_ADD = "/role/add";
export const ROLEDETAIL = "/role/details/:id";
export const UPDATE_ROLE = "/role/update/:id";

//  Affiliates
export const AFFILIATE_LIST = "/affiliates";
export const AFFILIATEDETAIL = "/affiliate/details/:id";
export const AFFILIATEDETAILS = "/affiliates/details/:id";
export const AFFILIATE_REQUEST = "/affiliate/requests";
export const AFFILIATE_LINK = "/my-link";
export const AFFILIATE_COMMISSION = "/commissions";
export const AFFILIATE_PRODUCTS = "/affiliated-products";
export const AFFILIATE_PRODUCT_ADD = "/affiliated-products/add";
export const AFFILIATE_BANKS_LIST = "/bank-list";
export const AFFILIATE_BANK_ADD = "/bank/add";
export const AFFILIATE_WITHDRAWALS = "/affiliate/withdrawals";
export const WITHDRAWALS_LIST = "/withdraw-list";
export const WITHDRAW_ADD = "/withdraw/add";
export const WITHDRAWDETAIL = "/withdraw/details/:id";

//  Orders
export const ORDER_LIST = "/orders";
export const ORDERDETAIL = "/order/details/:id";
export const ORDEREMAILDETIAL = "/order-email/details/:id";

//  Shipping
export const SHIPPING_LIST = "/shippings";
export const SHIPPING_ADD = "/shipping/add";
export const UPDATE_SHIPPING = "/shipping/update/:id";

//  Coupons
export const COUPON_LIST = "/coupons";
export const COUPON_ADD = "/coupon/add";
export const COUPONDETAIL = "/coupon/details/:id";
export const UPDATECOUPON = "/coupon/update/:id";

//  Posts
export const POST_LIST = "/posts";
export const POST_ADD = "/post/add";
export const POSTSDETAIL = "/post/details/:id";
export const UPDATEPOSTS = "/post/update/:id";

//  Payments
export const PAYMENT_LIST = "/payments";
export const PAYMENTDETAIL = "/payment/details/:id";

//  Gallery & Images
export const GALLERY_LIST = "/gallery";
export const GALLERYDETAIL = "/gallery/details/:id";
export const RENDERED_IMAGES_LIST = "/rendered-images";
export const RENDEREDIMAGESDETAIL = "/rendered-images/details/:id";

//  Logs
export const LOGS_LIST = "/sync-logs";
export const LOGSDETAIL = "/log/details/:id";

//  Contacts
export const CONTACT_LIST = "/contacts";
export const CONTACTDETAIL = "/contact/details/:id";

//  API Keys
export const API_KEYS_LIST = "/api-keys";
export const API_KEYS_ADD = "/api-key/add";

//  Dealers
export const DEALER_LIST = "/dealers";

//  Bank Details
export const BANKDETAIL = "/bank/details/:id";
export const UPDATE_BANK = "/bank/update/:id";

//  Commission Details
export const COMMISSIONDETAIL = "/commission/details/:id";

//  Commission Details
export const SUBSCRIPTIONS = "/email-subscriptions";
export const SMS_SUBSCRIPTIONS = "/sms-subscriptions";

// FAQs
export const FAQ_LIST = "/faqs";
export const FAQ_ADD = "/faq/add";
export const FAQ_DETAIL = "/faq/details/:id";
export const FAQ_UPDATE = "/faq/update/:id";

//cart funnel
export const CART_FUNNEL_LIST = "/cart-funnels";
export const CART_FUNNEL_DETAIL = "/cart-funnels/details/:id";

// campaign
export const GENERAL_EMAIL_CAMPAIGN = "/campaign/general/email";
export const GENERAL_SMS_CAMPAIGN = "/campaign/general/sms";
export const CART_FUNNEL_EMAIL_CAMPAIGN = "/campaign/cart-funnel/email";
export const CART_FUNNEL_SMS_CAMPAIGN = "/campaign/cart-funnel/sms";
export const PENDING_ORDER_EMAIL_CAMPAIGN = "/campaign/pending-orders/email";
export const PENDING_ORDER_SMS_CAMPAIGN = "/campaign/pending-orders/sms";
export const UPDATE_EMAIL_CAMPAIGN = "/campaign/update-email-campaign/:id";
export const UPDATE_SMS_CAMPAIGN = "/campaign/update-sms-campaign/:id";
export const DETAILS_CAMPAIGN = "/campaign/details/:id";
export const SMS_ANALYTICS_CAMPAIGN = "/campaign/sms/analytics";
export const EMAIL_ANALYTICS_CAMPAIGN = "/campaign/email/analytics";

// outreach
export const OUTREACH_LIST = "/outreaches";
export const OUTREACH_ADD = "/outreach/add";
export const OUTREACH_DETAIL = "/outreach/details/:id";
export const OUTREACH_UPDATE = "/outreach/update/:id";

// Quotes
export const QUOTE_LIST = "/quotes";
export const QUOTE_DETAIL = "/quote/details/:id";

// Refund Requests
export const REFUND_REQUEST_LIST = "/refund-requests";

// Tracking
export const TRACKING_EVENTS = "/tracking/events";
export const TRACKING_STATS = "/tracking/stats";
export const TRACKING_LEADS = "/tracking/leads";
export const TRACKING_JOURNEY = "/tracking/journey";

// Notifications
export const NOTIFICATIONS = "/notifications";
